const makeHeader = (headers, xhr) => {
  if (headers && typeof headers === 'object') {
    for (let key in headers) {
      if (headers.hasOwnProperty(key)) {
        xhr.setRequestHeader(key, headers[key])
      }
    }
  }
  return xhr
}
class _Request {

  get(url, headers) {
    return new Promise((resolve, reject) => {
      let xhr = new XMLHttpRequest()
      xhr.open('GET', url, true)
      makeHeader(headers, xhr)
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve(xhr.response)
        } else {
          reject(xhr.statusText)
        }
      }
      xhr.onerror = () => reject(xhr.statusText)
      xhr.send()
    })
  }

  post(url, data, headers) {
    let formData = new FormData()
    if (data instanceof FormData) {
      formData = data
    } else {
      for (let d in data) {
        if (data.hasOwnProperty(d)) {
          formData.append(d, data[d])
        }
      }
    }
    return new Promise((resolve, reject) => {
      let xhr = new XMLHttpRequest()
      xhr.open('POST', url, true)
      makeHeader(headers, xhr)
      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve(JSON.parse(xhr.response))
        } else {
          reject(xhr.statusText)
        }
      }
      xhr.onerror = () => reject(xhr.statusText)
      xhr.send(formData)
    })
  }

  del(url, headers) {
    return new Promise((resolve, reject) => {
      let xhr = new XMLHttpRequest()
      xhr.open('DELETE', url, true)
      makeHeader(headers, xhr)
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve(xhr.response)
        } else {
          reject(xhr.statusText)
        }
      }
      xhr.onerror = () => reject(xhr.statusText)
      xhr.send()
    })
  }
}

export const Request =  new _Request()